import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view04ImageOptions } from './views/exterior_view04'

class XP55BathingPlatform extends Component {

    render() {
        let imageOptions = exterior_view04ImageOptions;

        let image = <ConfiguratorImage boat="XP55" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption>

                    <h1><Trans defaults='Bathing platform' /></h1>
                    
                    <p><Trans defaults='The transom door hides an integrated dinghy garage for an inflatable dinghy up to 3.2 m. The transom door forms, when  opened,  a comfortable bathing platform.' /></p>
                    <p><Trans defaults='Teak surface of the bathing platform is standard.' /></p>
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XP55BathingPlatform);


// WEBPACK FOOTER //
// ./src/XP55/XP55BathingPlatform.js